<template>
  <div>
    <div class="mb-3">
      <FormLabel label="名前 必須※30文字以内" />
      <FormItem
        v-model:value="title"
        :errors="errors"
        form-id="title"
        form-type="text"
      />
    </div>

    <div class="mb-3">
      <FormLabel label="説明 ※1000文字以内" />
      <FormItem
        v-model:value="remarks"
        :errors="errors"
        form-id="remarks"
        form-type="textarea"
      />
    </div>

    <ShowFormItemWrapper v-if="attachedUrl" title="添付動画 必須">
      <vue-plyr>
        <video controls crossorigin playsinline>
          <source :src="attachedUrl" type="video/mp4" />
        </video>
      </vue-plyr>
    </ShowFormItemWrapper>

    <div class="mb-3 mt-4 d-flex flex-column">
      <span v-if="attachedUrl" class="text-danger">
        新しく添付すると既存の添付動画は削除されます
      </span>

      <FormItemAttacheFile
        v-model="newAttacheds"
        :file-limit="1"
        :current-count="newAttacheds.length"
        :max-file-size-mb="30000"
        :errors="errors"
        :accept="'video/mp4'"
        form-id="newAttached"
        class="mb-3"
        :is-invalid="!!errors?.newAttached"
        :base64="false"
      />
    </div>

    <div class="mb-3">
      <FormLabel label="公開日時 ※未設定の場合は即座に公開されます" />
      <div class="d-flex">
        <FormItem
          v-model:value="publishedAt"
          :errors="errors"
          form-id="publishedAt"
          form-type="date"
          class="me-2"
          style="width: 210px; min-width: 210px"
        />
        <FormItemTime
          v-model:value="publishedAt"
          :env="publishedAtEnv"
          :errors="errors"
          form-id="publishedAt"
          label=""
          :minutes-increment="1"
        />
      </div>
    </div>

    <div class="mb-3">
      <FormLabel label="公開終了日時" />
      <div class="d-flex">
        <FormItem
          v-model:value="unpublishedAt"
          :errors="errors"
          form-id="unpublishedAt"
          form-type="date"
          class="me-2"
          style="width: 210px; min-width: 210px"
        />
        <FormItemTime
          v-model:value="unpublishedAt"
          :env="unpublishedAtEnv"
          :errors="errors"
          form-id="unpublishedAt"
          label=""
          :minutes-increment="1"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { formatTypeTranslater } from "/@/modules/format";
import { Label as FormLabel } from "/@/vue/components/Atom";
import {
  FormItem,
  FormItemTime,
  PdfForm,
  FormItemAttacheFile,
} from "/@/vue/components/Molecules";
import { ShowAttachedPdfs } from "/@/vue/components/Molecules/PDF";
import { ShowFormItemWrapper } from "/@/vue/components/Molecules/Form";
import Dropdown from "primevue/dropdown";
import { ZodFormattedErrors } from "/@/types";
import { axios } from "/@/modules/axios";
import { fromISO } from "/@/modules/luxon";

const title = defineModel<string>("title");
const remarks = defineModel<string>("remarks");
const newAttached = defineModel<File>("newAttached");
const publishedAt = defineModel<string | undefined>("publishedAt");
const unpublishedAt = defineModel<string | undefined>("unpublishedAt");

const props = defineProps<{
  attachedUrl?: string;
  errors: ZodFormattedErrors;
}>();

const newAttacheds = ref<File[]>([]);

watch(newAttacheds, (newValue) => {
  if (newValue.length > 0) {
    newAttached.value = newValue[0];
  }
});

const publishedAtEnv = computed(() => {
  if (!publishedAt.value) return;

  return fromISO(publishedAt.value)?.toObject();
});

const unpublishedAtEnv = computed(() => {
  if (!unpublishedAt.value) return;

  return fromISO(unpublishedAt.value)?.toObject();
});

function change(e: Event) {
  const target = e.target as HTMLInputElement;
  const file = target.files?.[0];
  if (file) {
    newAttached.value = file;
  }
}
</script>

<style scoped></style>
